export default "__VITE_ASSET__DVmyOsn2__"